import type { ReactNode } from "react";

import type { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";

import apiClient from "@/api/apiClient";
import queryClient from "@/api/queryClient";
import RouterError from "@/components/Router/RouterError";
import RouterLoading from "@/components/Router/RouterLoading";
import RouterNotFound from "@/components/Router/RouterNotFound";
import { routeTree, type FileRoutesByTo } from "@/routeTree.gen";

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

export interface BreadcrumbsContext {
  label: string;
  icon?: ReactNode;
  path?: keyof FileRoutesByTo;
}

export interface RouterContext {
  apiClient: typeof apiClient;
  queryClient: QueryClient;
  breadcrumbs: BreadcrumbsContext[];
}

export const router = createRouter({
  scrollRestoration: true,
  routeTree,
  context: {
    apiClient,
    queryClient,
    breadcrumbs: [] as BreadcrumbsContext[],
  },
  defaultPendingMs: 250,
  defaultPendingMinMs: 0,
  // Since we're using React Query, we don't want loader calls to ever be stale
  // This will ensure that the loader is always called when the route is preloaded or visited
  defaultPreload: "intent",
  defaultPreloadStaleTime: 0,
  defaultPreloadDelay: 100,
  defaultErrorComponent: RouterError,
  defaultPendingComponent: RouterLoading,
  defaultNotFoundComponent: RouterNotFound,
  defaultStructuralSharing: true,
});
